module.exports = __webpack_public_path__ + "static/media/collaborationEnisa.a170b010.png";